var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResume(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "resume",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.999,
    height: 20,
    viewBox: "0 0 19.999 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_150",
    "data-name": "Group 150"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_149",
    "data-name": "Group 149"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_260",
    "data-name": "Path 260",
    d: "M16.179,5.811a.391.391,0,0,0,.391-.391V1.172A1.173,1.173,0,0,0,15.4,0H1.179A1.173,1.173,0,0,0,.007,1.172V18.828A1.173,1.173,0,0,0,1.179,20H15.4a1.173,1.173,0,0,0,1.172-1.172V15.95a.391.391,0,1,0-.781,0v2.878a.391.391,0,0,1-.391.391H1.179a.391.391,0,0,1-.391-.391V1.172A.391.391,0,0,1,1.179.781H15.4a.391.391,0,0,1,.391.391V5.42A.391.391,0,0,0,16.179,5.811Z",
    transform: "translate(-0.007)",
    fill: "#324562"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_152",
    "data-name": "Group 152",
    transform: "translate(4.687 2.109)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_151",
    "data-name": "Group 151"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_261",
    "data-name": "Path 261",
    d: "M123.6,54a3.592,3.592,0,0,0-2.466,6.206.388.388,0,0,0,.042.039,3.587,3.587,0,0,0,4.847,0,.39.39,0,0,0,.042-.039A3.592,3.592,0,0,0,123.6,54Zm0,6.406a2.8,2.8,0,0,1-1.7-.573,1.953,1.953,0,0,1,3.4,0A2.8,2.8,0,0,1,123.6,60.406Zm-.625-2.969v-.254a.625.625,0,0,1,1.25,0v.254a.625.625,0,0,1-1.25,0Zm2.888,1.824a2.71,2.71,0,0,0-1.151-.965,1.4,1.4,0,0,0,.294-.859v-.254a1.406,1.406,0,1,0-2.812,0v.254a1.4,1.4,0,0,0,.294.859,2.71,2.71,0,0,0-1.151.965,2.813,2.813,0,1,1,4.527,0Z",
    transform: "translate(-120.007 -54)",
    fill: "#324562"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_154",
    "data-name": "Group 154",
    transform: "translate(7.891 17.109)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_153",
    "data-name": "Group 153"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_262",
    "data-name": "Path 262",
    d: "M204.507,438H202.4a.391.391,0,0,0,0,.781h2.109a.391.391,0,0,0,0-.781Z",
    transform: "translate(-202.007 -438)",
    fill: "#324562"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_156",
    "data-name": "Group 156",
    transform: "translate(4.453 14.922)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_155",
    "data-name": "Group 155"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_263",
    "data-name": "Path 263",
    d: "M119.944,382H114.4a.391.391,0,0,0,0,.781h5.547a.391.391,0,0,0,0-.781Z",
    transform: "translate(-114.007 -382)",
    fill: "#324562"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_158",
    "data-name": "Group 158",
    transform: "translate(4.453 12.734)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_157",
    "data-name": "Group 157"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_264",
    "data-name": "Path 264",
    d: "M119.944,326H114.4a.391.391,0,0,0,0,.781h5.547a.391.391,0,0,0,0-.781Z",
    transform: "translate(-114.007 -326)",
    fill: "#324562"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_160",
    "data-name": "Group 160",
    transform: "translate(2.784 10.547)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_159",
    "data-name": "Group 159"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_265",
    "data-name": "Path 265",
    d: "M71.954,270.114a.39.39,0,1,0,.114.276A.394.394,0,0,0,71.954,270.114Z",
    transform: "translate(-71.287 -270)",
    fill: "#324562"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_162",
    "data-name": "Group 162",
    transform: "translate(2.784 12.734)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_161",
    "data-name": "Group 161"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_266",
    "data-name": "Path 266",
    d: "M71.954,326.114a.39.39,0,1,0,.114.276A.394.394,0,0,0,71.954,326.114Z",
    transform: "translate(-71.287 -326)",
    fill: "#324562"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_164",
    "data-name": "Group 164",
    transform: "translate(2.784 14.922)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_163",
    "data-name": "Group 163"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_267",
    "data-name": "Path 267",
    d: "M71.954,382.114a.39.39,0,1,0,.114.276A.394.394,0,0,0,71.954,382.114Z",
    transform: "translate(-71.287 -382)",
    fill: "#324562"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_166",
    "data-name": "Group 166",
    transform: "translate(4.453 10.547)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_165",
    "data-name": "Group 165"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_268",
    "data-name": "Path 268",
    d: "M119.944,270H114.4a.391.391,0,0,0,0,.781h5.547a.391.391,0,0,0,0-.781Z",
    transform: "translate(-114.007 -270)",
    fill: "#324562"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_168",
    "data-name": "Group 168",
    transform: "translate(11.624 4.87)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_167",
    "data-name": "Group 167"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_269",
    "data-name": "Path 269",
    d: "M305.144,124.9a1.641,1.641,0,0,0-2.241.6l-4.916,8.514a.391.391,0,0,0-.05.152l-.346,3.1a.391.391,0,0,0,.62.358l2.511-1.849a.39.39,0,0,0,.107-.119l4.916-8.514A1.642,1.642,0,0,0,305.144,124.9Zm-6.677,11.565.181-1.618,1.131.653Zm1.881-1.539-1.488-.859,3.945-6.832,1.488.859Zm4.72-8.176-.385.667-1.488-.859.385-.667a.859.859,0,0,1,1.488.859Z",
    transform: "translate(-297.589 -124.675)",
    fill: "#324562"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResume);
export default __webpack_public_path__ + "static/media/Resume.3ef71e518f867e6f8b61fa0ca21f9c8f.svg";
export { ForwardRef as ReactComponent };